// extracted by mini-css-extract-plugin
export default {"title":"g3-z","warning":"h3-z","sizeOptionsLegendText":"i3-z"};